import { Id_category, Id_floor } from "./api/Identifiers";
import { Configuration } from "./Configuration";
import { DrawingsCollection } from "./drawings/DrawingsCollection";
import { Finding } from "./Findings";
import { Floor } from "./Floor";
import { Rectangle } from "./Rectangle";
import { Actions } from "./redux/Actions";
import { Dispatcher } from "./redux/Dispatcher";
import { get_state, State } from "./redux/State";
import { get_current_view_port_map } from "./ui/map/map_area";


function create_findings_print_object(): any {
    let state: State = get_state();
    let id_drawing = state.id_drawing;
    let findings_obj: any = {};
    let findings: any = [];
    let selected_findings_categories: Id_category[] = state.selected_findings_categories;
    let filtered_findings: Finding[] = state.findings.get_on_floor(state.id_floor).findings;
    if (selected_findings_categories.length > 0) {
        selected_findings_categories.forEach((category: Id_category) => {
            filtered_findings.forEach((finding: Finding) => {
                if (!finding.has_findingNumber) {
                    return;
                }
                if (finding.id_category.equals(category)) {
                    let xCoord: number = 1;
                    let yCoord: number = 1;
                    let p1x: number = state.drawing_p1p2.P1.X;
                    let p1y: number = state.drawing_p1p2.P1.Y;
                    let p2x: number = state.drawing_p1p2.P2.X;
                    let p2y: number = state.drawing_p1p2.P2.Y;
                    let label: string = "undefined";
                    if (finding.has_coords) {
                        xCoord = finding.adj_coords.X;
                        yCoord = finding.adj_coords.Y;
                    }
                    if (finding.raw.commonName) {
                        label = `${finding.raw.commonName} (${finding.location_label})`;
                    }
                    if (finding.adj_geo_ref.P1.X > 1) {
                        p1x = finding.adj_geo_ref.P1.X;
                    }
                    if (finding.adj_geo_ref.P1.Y > 1) {
                        p1y = finding.adj_geo_ref.P1.Y;
                    }
                    if (finding.adj_geo_ref.P2.X > 1) {
                        p2x = finding.adj_geo_ref.P2.X;
                    }
                    if (finding.adj_geo_ref.P2.Y > 1) {
                        p2y = finding.adj_geo_ref.P2.Y;
                    }
                    let index: number = finding.findingNumber;
                    let finding_obj: any = {
                        p1xCoord: p1x,
                        p1yCoord: p1y,
                        p2xCoord: p2x,
                        p2yCoord: p2y,
                        xCoord: xCoord,
                        yCoord: yCoord,
                        index: index,
                        label: label,
                    };
                    if (finding.is_delustered) {
                        finding_obj["adj_cluster_x"] = finding.adj_cluster_coords.X;
                        finding_obj["adj_cluster_y"] = finding.adj_cluster_coords.Y;
                    }
                    findings.push(finding_obj);
                }
            });
        });
    }

    findings_obj["findings"] = findings;
    findings_obj["id_drawing"] = id_drawing;
    let building: string = state.buildings.get_building(state.id_building).label;
    let floor_label: string = "";
    let drawings: DrawingsCollection = state.all_displayable_drawings.get_all_in_building(state.id_building);
    drawings.floors.floors.forEach((floor: Floor) => {
        let id_floor: Id_floor = floor.id;
        if (id_floor.equals(state.id_floor)) {
            floor_label = floor.label;
            return;
        }
    });
    let today: Date = new Date();
    findings_obj["report_title"] = "Test Report " + building + " " + floor_label;
    findings_obj["report_subtitle"] = today.toLocaleDateString();
    let rec: Rectangle = get_current_view_port_map();
    let crop_obj = {
        left: rec.Left,
        bottom: rec.Bottom,
        right: rec.Right,
        top: rec.Top,
    };
    findings_obj["crop"] = crop_obj;
    return findings_obj;
}

export function print_findings() {
    let obj: any = create_findings_print_object();
    var content = JSON.stringify(obj);
    if (obj.findings.length < 1) {
        alert("No findings are selected to be printed.");
    } else {
        Dispatcher.dispatch(Actions.ACTION_SET_PRINTING_FINDINGS, true);
        var request = new XMLHttpRequest();
        var url = `${Configuration.floorplan_api_gateway}/api/EocPdf`;
        request.open("POST", url, true);
        request.setRequestHeader("Content-type", "application/json");
        request.responseType = "blob";

        request.onload = function () {
            // Only handle status code 200
            if (request.status === 200) {
                // Try to find out the filename from the content disposition `filename` value
                var disposition = request.getResponseHeader("content-disposition");
                var matches = /"([^"]*)"/.exec(disposition);
                var filename = matches != null && matches[1] ? matches[1] : "file.pdf";

                // The actual download
                var blob = new Blob([request.response], { type: "application/pdf" });
                var link = document.createElement("a");
                link.href = window.URL.createObjectURL(blob);
                link.download = filename;

                document.body.appendChild(link);

                link.click();

                document.body.removeChild(link);
            } else {
                alert("There was an error. Could not print the findings");
                Dispatcher.dispatch(Actions.ACTION_SET_PRINTING_FINDINGS, false);
            }
            Dispatcher.dispatch(Actions.ACTION_SET_PRINTING_FINDINGS, false);
            // some error handling should be done here...
        };
        request.send(content);
    }
}
